jQuery.fn.slideFadeGallery = function () {
    var galleryObj = jQuery(this);

    config = {
        holderWidth: galleryObj.data('holder-width'),
        controlsCount: galleryObj.data('controls-count'),
        linkOpacity: 1,
        thumbsId: 'thumbs',
        thumbsDivId: 'productthumbsdiv',
        thumbsImgWidth: 192,
        easeFunc: 'easeInOutExpo',
        div: 'productimage',
        file: 'display_itemimage.php',
        initialText: '',
        initialClass: '',
        initialHref: '',
        initialRel: 0
    }

    var thumbsPos = 0;
    var thumbsArray;
    var thumbsIndex = 0;
    var lefta;
    var righta;
    var initial;
    var initiala;
    var prev;
    var next;
    var preva;
    var nexta;
    var posx;
    var posy;
    var thumbsMov;

    thumbsArray = $('#' + config.thumbsId + ' a');

    if (thumbsArray.length > 1) {
        var i = 0;
        thumbsArray.each(function () {
            $(this).click(function (event) {
                event.preventDefault();
            });

            $(this).mouseenter(function () {
                if ($(this).attr('class') != 'active') {
                    gid = $(this).data('id');

                    thumbsIndex = thumbsArray.index($(this));

                    galleryThumb(gid);

                    thumbsArray.css('opacity', 1);
                    thumbsArray.removeClass('active');

                    $(this).fadeTo('fast', .5);
                    $(this).addClass('active');
                }
            });

            if (i == 0) {
                $(this).css('opacity', .5);
            }

            i++;
        });

    } else {
        thumbsArray.each(function () {
            $(this).click(function (event) {
                event.preventDefault();
            });
        });
    }

    var thumbs = $('#' + config.thumbsId);
    var thumbsWidth = (thumbs.width() - 2); // minus padding
    var thumbsDiv = $('#' + config.thumbsDivId);
    var debug = $('#debug');
    var thumbsMov = (config.holderWidth - config.thumbsImgWidth);
    var availWidth = (thumbsWidth - config.holderWidth);

    if (thumbsArray.length > config.controlsCount) {
        var controls = $('<ul></ul>').addClass('controls').css({
            'width': config.holderWidth
        });
        // Left link
        var left = $('<li></li>').addClass('left');
        lefta = $('<a></a>').attr('id', 'left').text('Left').attr('href', '#').css({
            'opacity': 0,
            'display': 'none'
        });
        left.append(lefta);

        // Right link
        var right = $('<li></li>').addClass('right');
        righta = $('<a></a>').attr('id', 'right').text('Right').attr('href', '#').css('opacity', config.linkOpacity);
        right.append(righta);

        // Events
        lefta.click(function (event) {
            gallerySlideThumbs('+');
            event.preventDefault();
        });

        righta.click(function (event) {
            gallerySlideThumbs('-');
            event.preventDefault();
        });

        // Combine controls
        controls.append(left).append(right);
        righta.css({
            'opacity': 1,
            'display': 'block'
        });
        jQuery(this).append(controls);

    }

    function gallerySlideThumbs(dir) {
        lefta.css({
            'opacity': 0,
            'display': 'none'
        });
        righta.css({
            'opacity': 0,
            'display': 'none'
        });

        var thumbsMovTmp = thumbsMov;


        // Right max
        if (((availWidth + thumbsPos) < thumbsMov) && dir == '-') {
            thumbsMovTmp = (availWidth + thumbsPos);
        }

        // Left max
        if (((thumbsPos + thumbsMov) >= 0) && dir == '+') {
            thumbsMovTmp = -thumbsPos;
        }

        thumbsDiv.animate({
            left: dir + "=" + thumbsMovTmp
        }, 500, config.easeFunc, function () {
            if (-thumbsPos < availWidth) {
                righta.css('display', 'block');
                righta.animate({
                    opacity: config.linkOpacity
                });
            }
            if (thumbsPos < 0) {
                lefta.css('display', 'block');
                lefta.animate({
                    opacity: config.linkOpacity
                });
            }
        });

        thumbsPos = eval(thumbsPos + '' + dir + '' + thumbsMovTmp);

        //debug.html(thumbsPos);
    };
    function galleryThumb(gid) {
        var divObj = $('#' + config.div);
        var url = '/inc/' + config.file;

        divObj.fadeTo(0, 0);
        galleryObj.addClass('loading');

        divObj.css('min-height', Math.floor(divObj.height()));

        $.ajax({
            type: 'GET',
            url: url,
            data: 'gid=' + gid,
            success: function (response) {
                divObj.html(response);
                divObj.fadeTo(200, 1);
                galleryObj.removeClass('loading');
                divObj.find('img').on('load', function () {
                    divObj.css('min-height', 0);
                });
            }
        });
    };
};

$('#productimageholder').slideFadeGallery();
